import { fmhAPI, PBM_API_URL } from 'api/APIBase';

/** POSTS a request to remove a lock for a treatment */
export async function postRemoveLock({ treatmentId, payerId, reason, source }) {
    const url = `${PBM_API_URL}/locks/${treatmentId}/unlock`;
    return fmhAPI.base
        .url(url)
        .post({
            payer_id: payerId,
            user_action_info: {
                reason,
                source,
            },
        })
        .json();
}

/** POSTS a request to add a lock for a treatment */
export async function postAddLock({ treatmentId, payerId, lockDates, reason, source }) {
    const url = `${PBM_API_URL}/locks/${treatmentId}/lock`;
    return fmhAPI.base
        .url(url)
        .post({
            payer_id: payerId,
            lock_period: lockDates
                ? {
                      start: lockDates[0],
                      end: lockDates[1],
                  }
                : null,
            user_action_info: {
                reason,
                source,
            },
        })
        .json();
}
